export const validateRequireLowercaseLetters = (value: string): boolean => {
  return value.toUpperCase() !== value;
};
